import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/dark-theme.css';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered HTML from react-snap exists — hydrate to preserve it.
  // This prevents the LCP element from being destroyed and re-created,
  // keeping the hero visible while lazy chunks download.
  ReactDOM.hydrateRoot(rootElement, app, {
    onRecoverableError: () => {
      // Intentionally empty: suppress console.error for recoverable hydration
      // mismatches (React errors #418 and #423). react-snap pre-renders static
      // HTML that may differ from the initial client render (lazy components,
      // async data from contexts, conditional JSON-LD schemas). React
      // automatically recovers by client-rendering mismatched subtrees —
      // no user-visible impact. Logging these to console costs Lighthouse
      // Best Practices points with zero debugging value in a react-snap setup.
    }
  });
} else {
  // Dev mode or no pre-rendered content — create fresh root
  ReactDOM.createRoot(rootElement).render(app);
} 